import SvgIcon from '@components/SvgIcon'
import { FunctionComponent } from 'react'
import styled, { css, useTheme } from 'styled-components'

interface SummaryMarqueeItemProps {
  category: string
  title: string
}

const StyledMarqueeItem = styled.div`
  ${({
    theme: {
      spacing: { spacing4 },
      typography: {
        headings: { xsmall: headingXSmall },
      },
      color: {
        primary: { primary02 },
      },
    },
  }) => css`
    display: flex;
    flex-direction: column;
    gap: ${spacing4};
    color: ${primary02};
    ${headingXSmall};
    width: 250px;
  `}
`

const StyledMarqueeItemCategory = styled.div`
  ${({
    theme: {
      color: {
        primary: { blickRed: blickRedColor, primary02 },
      },
      typography: {
        subheads: { xsmall1: subheadXSmall1 },
      },
      spacing: { spacing4, spacing2 },
    },
  }) => css`
    display: flex;
    gap: ${spacing4};
    align-items: center;
    background-color: ${primary02};
    width: fit-content;
    padding: 0 ${spacing2};
    & > div {
      color: ${blickRedColor};
      margin: auto 0;
      ${subheadXSmall1}
      display: flex;
      padding-top: 1px;
    }
  `}
`

const StyledMarqueeItemTitle = styled.div`
  ${({
    theme: {
      utils: { ellipsis },
    },
  }) => css`
    ${ellipsis('100%', 2)}
  `}
`

const SummaryMarqueeItem: FunctionComponent<SummaryMarqueeItemProps> = ({
  category,
  title,
}) => {
  const { color } = useTheme()
  return (
    <StyledMarqueeItem>
      <StyledMarqueeItemCategory>
        <SvgIcon iconName="stars" size={16} color={color.primary.blickRed} />
        <div>{category}</div>
      </StyledMarqueeItemCategory>
      <StyledMarqueeItemTitle>{title}</StyledMarqueeItemTitle>
    </StyledMarqueeItem>
  )
}

export default SummaryMarqueeItem
